import * as React from 'react';
import { LocationWithCoordinates } from 'lib/types';
import { LocationsContext } from 'core/components/LocationsProvider';

export type MaybeLocation = LocationWithCoordinates | null;

function getLocation(
    locationId: string,
    locations: ReadonlyArray<LocationWithCoordinates>,
): MaybeLocation {
    if (locationId === '') {
        return null;
    }

    return locations.find(({ _id }) => _id === locationId) || null;
}

export default function useLocationData(
    locationId: string | null,
): MaybeLocation {
    const { locations } = React.useContext(LocationsContext);
    const [location, setLocation] = React.useState<MaybeLocation>(() =>
        locationId ? getLocation(locationId, locations) : null,
    );

    React.useEffect(() => {
        let handle: number | undefined = requestAnimationFrame(() => {
            handle = requestAnimationFrame(() => {
                handle = undefined;
                if (locationId) {
                    setLocation(getLocation(locationId, locations));
                } else {
                    setLocation(null);
                }
            });
        });

        return () => {
            if (handle !== undefined) {
                cancelAnimationFrame(handle);
            }
        };
    }, [locationId, locations]);

    return location;
}
